<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('xlsx-to-pdfa-converter', 'XLSX → PDF/A');

function handleBatchCreated(batchId: string) {
  console.log('[XLSX PDF/A Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[XLSX PDF/A Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[XLSX PDF/A Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[XLSX PDF/A Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[XLSX PDF/A Converter] Credits updated:', credits);
}
</script>
